import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Donut } from "../models/Donut";

export const getDonuts = async (
	params: { partId?: number | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (params.partId) parameters.push({ name: "PartId", value: params.partId });

	const resp = await apiService.callV2("[M2].[GetDonuts]", parameters, signal);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Donut[];
	} else {
		throw new Error(resp.message || "Error fetching donuts");
	}
};
export const upsertDonut = async (donut: Donut) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "PartId", value: donut.PartId },
		{ name: "PartName", value: donut.PartName },
		{ name: "LocationId", value: donut.LocationId },
		{ name: "DonutStatusCode", value: donut.DonutStatusCode },
		{ name: "Diameter", value: donut.Diameter ? Number(donut.Diameter) : null },
		{
			name: "NewDiameter",
			value: donut.NewDiameter ? Number(donut.NewDiameter) : null,
		},
		{
			name: "ScrapDiameter",
			value: donut.ScrapDiameter ? Number(donut.ScrapDiameter) : null,
		},
		{ name: "Width", value: donut.Width ? Number(donut.Width) : null },
		{ name: "SectionFamilyId", value: donut.SectionFamilyId },
		{ name: "Comments", value: donut.Comments },
	];

	const resp = await apiService.callV2("[M2].[UpsertDonut]", parameters);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error upserting donut");
	}
};

export const deleteDonut = async (partIds: string | null) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "PartIds", value: partIds }];

	const resp = await apiService.callV2("[M2].[DeleteDonut]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting donut");
	}
};
